import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import acceptedConsentsApi from '@/features/dashboard/acceptedConsents/api/acceptedConsentsApi.ts';
import { acceptedConsentsApiQueryKeys } from '@/features/dashboard/acceptedConsents/api/acceptedConsentsApi.queryKeys.ts';
import { bookingsApiQueryKeys } from '@/features/dashboard/bookings/api/bookingsApi.queryKeys.ts';

interface UseWithdrawAcceptedConsentParams {
  bookingId?: string;
}

const useWithdrawAcceptedConsent = ({
  bookingId,
}: UseWithdrawAcceptedConsentParams = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (acceptedConsentId: string) =>
      acceptedConsentsApi.withdraw(acceptedConsentId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: acceptedConsentsApiQueryKeys.all(),
      });
      if (bookingId) {
        queryClient.invalidateQueries({
          queryKey: bookingsApiQueryKeys.acceptedConsents(bookingId),
        });
      }
      toast.success('Zgoda została wycofana');
    },
    onError: (error: Error) => {
      toast.error('Nie udało się wycofać zgody', {
        description: error.message,
      });
    },
  });
};

export default useWithdrawAcceptedConsent;
